module.exports = __webpack_public_path__ + "static/media/contact-mail.41d6f44a.svg";